import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../utils/api';
import { useAuth } from '../../contexts/AuthContext';
import { SalesDocumentList } from '../sales/SalesDocumentViews';
import { type Header, type Kind, PAGE_SIZE } from '../sales/documentTypes';

export default function ClientDocumentsTab({ clientId, kind }: { clientId: string; kind: Kind }) {
  const { tenant } = useAuth();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const documents = useQuery({
    queryKey: ['commercial-documents', tenant?.id, 'client', clientId, kind, search, page],
    enabled: !!tenant?.id && !!clientId,
    queryFn: async () => (await apiClient.client.get<{ data: Header[]; has_more: boolean; pagination: { total: number } }>('/documenti-commerciali', {
      params: { cliente_id: clientId, tipo: kind, search, page, limit: PAGE_SIZE, solo_importate: kind === 'offerta' ? true : undefined },
    })).data,
  });
  const tab = { offerta: 'offerte', ordine: 'ordini', ddt: 'ddt', fattura: 'fatture' }[kind];
  return <SalesDocumentList kind={kind} documents={documents.data?.data || []} loading={documents.isLoading}
    error={documents.isError ? 'Impossibile caricare i documenti di questo cliente.' : undefined}
    page={page} onPage={setPage} search={search} onSearch={value => { setSearch(value); setPage(1); }}
    hasMore={!!documents.data?.has_more} total={documents.data?.pagination?.total} selectionCount={0}
    returnTo={`/clients/${clientId}?tab=${tab}`} />;
}
